
import { defineComponent, computed, PropType } from 'vue';
import type { BadgeSize, BadgeVariant, BadgeColors } from './displayTypes';

export default defineComponent({
  name: 'SpmBadge',

  props: {
    label: {
      type: String,
      required: true,
    },

    icon: {
      type: String,
      default: '',
    },

    /**
     * Colors can be passed as an object with bg and color properties
     * or use CSS variables via style binding
     */
    colors: {
      type: Object as PropType<BadgeColors>,
      default: null,
    },

    /**
     * Size of the badge: 'sm', 'md', 'lg'
     */
    size: {
      type: String as PropType<BadgeSize>,
      default: 'md',
    },

    /**
     * Variant style: 'filled', 'outlined', 'soft'
     */
    variant: {
      type: String as PropType<BadgeVariant>,
      default: 'soft',
    },

    /**
     * Whether to display text in uppercase
     */
    uppercase: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const badgeStyle = computed(() => {
      if (!props.colors) return {};

      const style: Record<string, string> = {
        '--badge-bg': props.colors.bg,
        '--badge-color': props.colors.color,
      };

      if (props.colors.borderColor) {
        style['--badge-border-color'] = props.colors.borderColor;
      }

      return style;
    });

    const sizeClass = computed(() => `spm-badge--${props.size}`);
    const variantClass = computed(() => {
      const classes = [`spm-badge--${props.variant}`];
      if (props.uppercase) {
        classes.push('spm-badge--uppercase');
      }
      return classes;
    });

    return {
      badgeStyle,
      sizeClass,
      variantClass,
    };
  },
});
